var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-aside"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackTop),expression:"showBackTop"}],staticClass:"back-top",on:{"click":_vm.scrollToTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }